<template>
  <div class="content">
    <p>
      {{
        company
      }}（以下「当社」）は、株式会社RYODEN（「以下RYODEN」）と締結した
      「PESCLEサービス利用許諾基本契約」（以下「本契約」）に基づき本サービスの利用を顧客に再許諾するにあたり、
      次の点について承諾し、本サービスを提供する。
    </p>
    <ul>
      <li>
        当社は、本契約に定める当社の義務と同等の義務を自らの責任で顧客に課すこと
      </li>
      <li>
        RYODENによる本サービスの許諾・提供は、あくまでも当社に対するものであり、顧客からの問い合わせ、請求、クレーム等にRYODENが直接対応することはないこと、こうした問い合わせ等については当社が対応すること
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    company: {
      type: String,
      require: true,
    },
  },
};
</script>
